import { LogLevel, PassedInitialConfig } from 'angular-auth-oidc-client';

import { environment } from '../../../environments/environment';

/**
 * El mismo realm que usa el resto de la suite, que es el punto entero: quien inició sesión en
 * Console llega aquí con la cookie SSO del realm ya puesta y no se le vuelve a pedir nada.
 *
 * `redirectUrl` se deriva de window.location.origin y NO se hardcodea: el realm tiene registrado
 * `http://localhost:4200/*` y solo eso, así que no puede desviarse del puerto en que la app se
 * sirve de verdad — el puerto está fijado en angular.json y en `npm start`.
 */
export const realmAuthConfig: PassedInitialConfig = {
  config: {
    authority: environment.realmAuthority,
    redirectUrl: `${window.location.origin}/launch`,
    postLogoutRedirectUri: window.location.origin,
    clientId: environment.realmClientId,
    scope: 'openid profile email',
    responseType: 'code',
    // PKCE S256 es obligatorio en el realm; la librería lo deriva de responseType=code.
    silentRenew: true,
    useRefreshToken: true,
    // El realm rota refresh tokens y revoca al reusarlos, así que un renew no se reintenta a ciegas.
    renewTimeBeforeTokenExpiresInSeconds: 30,
    ignoreNonceAfterRefresh: true,
    logLevel: LogLevel.Warn,
  },
};
